import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthProvider';
import Topbar from '@/components/platform/Topbar';
import { LoadingScreen, MemberMissingScreen } from '@/components/platform/Guards';

export default function PendingPage() {
  const { loading, memberLoading, session, member, refreshMember, signOut } = useAuth();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(false);

  if (loading || memberLoading) return <LoadingScreen label="회원 정보를 확인하고 있어요…" />;
  if (!session) return <Navigate to="/login" replace />;
  if (!member) return <MemberMissingScreen />;
  if (member.role === 'admin') return <Navigate to="/admin" replace />;
  if (member.status === 'approved') return <Navigate to="/my" replace />;

  const rejected = member.status === 'rejected';

  const handleRefresh = async () => {
    setChecking(true);
    await refreshMember();
    setChecking(false);
  };

  const handleSignOut = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  return (
    <div className="pf-page">
      <Topbar />
      <div className="pf-status-hero">
        <div className="pf-status-icon" aria-hidden="true">
          <i className={rejected ? 'ri-close-circle-line' : 'ri-time-line'} />
        </div>
        <h1>{rejected ? '가입이 승인되지 않았어요' : '운영자 승인을 기다리고 있어요'}</h1>
        <p>
          {rejected
            ? '운영자가 가입을 승인하지 않았어요. 문의가 필요하시면 운영자에게 연락해 주세요.'
            : '가입 신청이 접수되었어요. 운영자가 승인하면 청첩장을 만들 수 있어요. 승인 후 아래 버튼을 눌러 확인해 주세요.'}
        </p>

        <div className="pf-alert info" style={{ maxWidth: '46ch', textAlign: 'left' }}>
          <i className="ri-mail-line" aria-hidden="true" />
          <span>
            <strong>{member.name || member.email}</strong>
            <br />
            {member.email}
          </span>
        </div>

        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
          {!rejected ? (
            <button type="button" className="pf-btn primary" onClick={() => void handleRefresh()} disabled={checking}>
              <i className={checking ? 'ri-loader-4-line spin-anim' : 'ri-refresh-line'} aria-hidden="true" />
              승인 상태 새로고침
            </button>
          ) : null}
          <button type="button" className="pf-btn ghost" onClick={() => void handleSignOut()}>
            <i className="ri-logout-box-r-line" aria-hidden="true" />
            로그아웃
          </button>
        </div>
      </div>
    </div>
  );
}